import PageHeaderBlock from '@/registry/evo-shadcn/blocks/page-header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign } from 'lucide-react';

export function ProfitabilityPage() {
  return (
    <div className="space-y-6">
      <PageHeaderBlock
        title="Project Profitability"
        subtitle="Real-time project margin and profitability analysis"
        size={20}
        showActions={false}
      />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <DollarSign className="h-5 w-5 text-success-600" />
            Profitability Analysis
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            This feature is in preview. Enable Live Mode in Feature Labs to use with your real data.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
